<template>
    <v-data-table v-model="selected" :headers="headers" :items="items" v-bind="attrs_table">
        <template #[`item.term`]="{ item }">
            <v-edit-dialog>
                <div>{{ item.term.ko }}</div>
                <div>{{ item.term.en }}</div>
                <template #input>
                    <v-text-field v-model="item.term.ko" v-bind="attrs_input" label="분류명(국문)" class="my-3" @input="emit" />
                    <v-text-field v-model="item.term.en" v-bind="attrs_input" label="분류명(영문)" class="my-3" @input="emit" />
                </template>
            </v-edit-dialog>
        </template>
        <template #[`item.type`]="{ item }">
            <v-edit-dialog>
                {{ workClassificationTypes.find(({ value }) => value == item.type)?.text }}
                <template #input>
                    <v-select label="표기유형" v-model="item.type" :items="workClassificationTypes" v-bind="attrs_input" class="my-3" @input="emit" />
                </template>
            </v-edit-dialog>
        </template>
        <template #[`item.desc`]="{ item }">
            <v-edit-dialog>
                <template v-if="item.type == LIST.value">
                    <v-row v-if="item.list.length > 0" no-gutters style="width: 100%; background: white; pointer-events: none" class="pl-1 pb-1 mx-n1">
                        <v-col v-for="{ term, isIt } in item.list" :key="term" :cols="item.list.length > 2 ? 4 : 12" class="pa-0 pt-1 pr-1">
                            <template v-if="isIt">
                                <v-chip outlined class="rounded-0 d-flex justify-center">{{ term }}</v-chip>
                            </template>
                            <template v-else>
                                <v-chip color="grey lighten-3" text-color="grey" class="rounded-0 d-flex justify-center">{{ term }}</v-chip>
                            </template>
                        </v-col>
                    </v-row>
                    <template v-else>추가된 항목이 없습니다</template>
                </template>
                <template v-if="item.type == DESC.value">
                    <div>{{ item.desc }}</div>
                </template>
                <template #input>
                    <template v-if="item.type == LIST.value">
                        <classification-list-combobox v-model="item.list" v-bind="{ ...attrs_input, class: 'my-3' }" @input="emit" />
                    </template>
                    <template v-if="item.type == DESC.value">
                        <v-text-field label="텍스트" v-model="item.desc" v-bind="attrs_input" class="my-3" @input="emit" />
                    </template>
                </template>
            </v-edit-dialog>
        </template>
        <template #[`item.actions`]="{ item }">
            <v-btn text icon color="red darken-4" @click="remove(item)">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
        </template>
        <template #footer>
            <v-divider />
            <v-row align="center" no-gutters>
                <v-col cols="auto" class="px-4 py-2">
                    <v-icon :disabled="upDisabled" @click="upItem">mdi-chevron-up</v-icon>
                    <v-icon :disabled="downDisabled" @click="downItem">mdi-chevron-down</v-icon>
                </v-col>
                <v-spacer />
                <v-col cols="auto" class="px-4 py-2 ml-auto">
                    <v-btn text icon color="primary darken-4" @click="add">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-data-table>
</template>

<script>
import ClassificationListCombobox from "./classification-list-combobox.vue";
import { attrs_input, WORK_CLASSIFICATION_TYPES } from "@/assets/variables";
const { NULL, DESC, LIST } = WORK_CLASSIFICATION_TYPES;
const attrs_table = {
    "item-key": "_id",
    "show-select": true,
    "disable-sort": true,
    "single-select": true,
    "items-per-page": -1,
    "disable-filtering": true,
    "hide-default-footer": true,
};
const headers = [
    { text: "표기유형", value: "type", width: 90 },
    { text: "분류명", value: "term", width: 220 },
    { text: "상세내용", value: "desc" },
    { text: "", value: "actions" },
];
const workClassificationTypes = Object.values(WORK_CLASSIFICATION_TYPES);
const initItem = () => ({ _id: Math.random(), term: { ko: "", en: "" }, type: NULL.value, text: null, list: [] });
export default {
    components: {
        ClassificationListCombobox,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        attrs_input,
        attrs_table,

        headers,
        items: [],
        selected: [],
        workClassificationTypes,
        DESC,
        LIST,
    }),
    computed: {
        upDisabled() {
            if (!this.selected[0] || (this.items || []).length < 1) return true;
            return this.selected?.[0]?._id == this.items?.[0]?._id;
        },
        downDisabled() {
            if (!this.selected[0] || (this.items || []).length < 1) return true;
            return [...(this.selected || [])]?.pop()?._id == [...(this.items || [])]?.pop()?._id;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.items = [...this.value];
        },
        emit() {
            this.$emit("input", this.items);
        },

        add() {
            this.items.push({ ...initItem() });
            this.emit();
        },
        remove(target) {
            this.items = this.items.filter((item) => item !== target);
            this.selected = [];
            this.emit();
        },
        upItem() {
            const index = (this.items || []).findIndex(({ _id }) => _id == this.selected[0]?._id);
            this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
            this.emit();
        },
        downItem() {
            const index = (this.items || []).findIndex(({ _id }) => _id == this.selected[0]?._id);
            this.items.splice(index, 2, this.items[index + 1], this.items[index]);
            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-small-dialog__activator {
    display: flex;
    align-items: center;

    width: 100%;
    height: 100%;

    &__content {
        display: block;
        width: 100%;
    }
}
</style>
